import { RouteObject } from 'react-router-dom'
import ReleaseNotesList from './components/List'
import ReleaseNotesEditor from './components/Editor'

// Route configuration
const ReleaseNotesModule: RouteObject = {
    path: 'release-notes',
    children: [
        {
            index: true,
            element: <ReleaseNotesList />,
        },
        {
            path: 'create',
            element: <ReleaseNotesEditor />,
        },
    ],
}

export default ReleaseNotesModule
